// Dosimira hediye kutusu (snippets/gift-pack.liquid) davranisi. layout/theme.liquid'den her sayfada yuklenir:
// sepet cekmecesi sonradan JS ile cizildiginde inline script calismiyordu (2026-10-22 hata).
(function () {
  if (window.__dsGiftPack) return;
  window.__dsGiftPack = true;
  var GIFT_SINGLE = 'Hediye olarak gönderilsin';
  var GIFT_MULTI = 'Her ürün ayrı ayrı paketlensin';
  var timer;
  function clean(v) { return String(v || '').replace(/[<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, 100); }
  function save(attrs) {
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-gift-pack-input]')) {
      var checked = t.checked;
      document.querySelectorAll('[data-gift-pack-input]').forEach(function (c) { c.checked = checked; });
      document.querySelectorAll('[data-gift-pack-names]').forEach(function (n) { n.hidden = !checked; });
      if (checked) {
        save({ 'Hediye paketi': t.getAttribute('data-gift-value') === GIFT_SINGLE ? GIFT_SINGLE : GIFT_MULTI });
      } else {
        document.querySelectorAll('[data-gift-pack-names-input]').forEach(function (i) { i.value = ''; });
        save({ 'Hediye paketi': '', 'Kart isimleri': '' });
      }
    } else if (t.matches('[data-gift-pack-names-input]')) {
      clearTimeout(timer);
      save({ 'Kart isimleri': clean(t.value) });
    }
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-gift-pack-names-input]')) return;
    document.querySelectorAll('[data-gift-pack-names-input]').forEach(function (i) { if (i !== t) i.value = t.value; });
    clearTimeout(timer);
    timer = setTimeout(function () { save({ 'Kart isimleri': clean(t.value) }); }, 600);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-gift-pack-names-input]')) {
      e.preventDefault();
      e.target.blur();
    }
  });
})();
